import Layout from '@/admin/js/layout';

const referralRoutes = {
    name: 'referral',
    path: '/referral',
    component: Layout,
    meta: { title: 'Партнёрская программа', noCache: false },
    redirect: '/referral/program',
    children: [
        {
            path: 'program',
            component: () => import('@/admin/js/views/referral/Program.vue'),
            name: 'ReferralProgram',
            meta: {
                title: 'Партнёрская программа',
            },
        },
        {
            path: '/widgets/:id/statistics',
            component: () => import('@/admin/js/views/referral/WidgetStatistics.vue'),
            name: 'WidgetStatistics',
            meta: { title: 'Статистика виджета', noCache: true },
            props: true,
        }

    ],

};

export default referralRoutes;
